export const comments_5588478 = {"data":{"data":[],"links":{}}}